import { instance } from "api/apiBase";
import { BulkImportStatus, ImportableLockbox } from "api/lockboxImport";

const BASE_ENDPOINT_URL = "/portal/v1/external_integrations/codebox";

export const codeboxApi = {
  getLockboxes: async (accountId: number): Promise<ImportableLockbox[]> => {
    const { data } = await instance.get<ImportableLockbox[]>(
      `${BASE_ENDPOINT_URL}/lockboxes`,
      { params: { account_id: accountId } }
    );
    return data;
  },

  bulkImportLockboxes: async (
    accountId: number,
    serial_numbers: string[]
  ): Promise<void> => {
    await instance.post(`${BASE_ENDPOINT_URL}/lockboxes/bulk_import`, {
      account_id: accountId,
      serial_numbers
    });
  },

  getBulkImportStatus: async (): Promise<BulkImportStatus> => {
    const { data } = await instance.get<BulkImportStatus>(
      `${BASE_ENDPOINT_URL}/lockboxes/bulk_import_status`
    );
    return data;
  }
};
